import React, { useCallback, useState } from "react";
import { Button, Header2, Menu } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import { ConversationMenuOptions } from "../ConversationMenuOptions.jsx";

export const HeaderNameMenu = ({ name, showStatus, statusClassName, onLeave }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleLeaveSuccess = useCallback(() => {
    handleClose();
    typeof onLeave === "function" && onLeave();
  }, [handleClose, onLeave]);

  return (
    <Menu
      target={
        <Button
          variant="text gray"
          active={open}
          className="tw-w-auto tw-min-w-0 tw-py-6 tw-px-1"
        >
          <>
            {showStatus ? (
              <div
                className={classnames(
                  "header-user-status tw-w-3 tw-h-3 tw-border-full tw-mr-2 tw-shrink-0",
                  statusClassName
                )}
              />
            ) : null}
            <Header2
              weight="bold"
              color="primary"
              className="tw-truncate"
            >
              {name}
            </Header2>
          </>
        </Button>
      }
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      mode="tiny"
    >
      <ConversationMenuOptions
        onOptionClick={handleClose}
        onLeaveSuccess={handleLeaveSuccess}
      />
    </Menu>
  );
};

HeaderNameMenu.propTypes = {
  name: PropTypes.string,
  showStatus: PropTypes.bool,
  statusClassName: PropTypes.string,
  onLeave: PropTypes.func,
};

HeaderNameMenu.defaultProps = {
  name: "",
  showStatus: false,
};
